import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  InitialAvatarIcon,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { IOrderAlert } from '@/modules/wealth/services/portfolio-orders';

interface Props {
  isOpen: boolean;
  details?: IOrderAlert | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RedemptionModal',
  props: {
    isOpen: { type: Boolean },
    details: null
  },
  setup(__props: any) {



return { __sfc: true,Modal, InitialAvatarIcon, Heading, BaseText }
}

})